<div class="loader-map">
    <mat-spinner [strokeWidth]="2" [diameter]="38"></mat-spinner>
</div>